import App from './App';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import { AllData } from './Data/AllData';
import AllProperties from './Properties/AllProperties';
import AllDetails from './PropDetails/AllDetails';
import AllContact from './Contact/AllContact';
import ScrollToTop from 'react-scroll-to-top';
import AllProducts from './Products/AllProducts';
import AllSingleproduct from './Singleproduct/AllSingleproduct';
import AllShop from './Shop/AllShop';
import AllCart from './Cart/AllCart';

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
    },
    {
        path: "Properties",
        element: <AllProperties/>
    },
    {
        path: "Property Details",
        element: <AllDetails/>
    },
    {
        path: "Contact Us",
        element: <AllContact/>
    },
    {
        path: "Products",
        element: <AllProducts/>
    },
    {
        //  طريقه ثابته عشان استقبل ال id
        path: "Singleproduct/:id", 
        element: <AllSingleproduct/>
    },
    {
        path: "Shop", 
        element: <AllShop/>
    },
    {
        path: "Cart", 
        element: <AllCart/>
    },

]);

createRoot(document.getElementById("root")).render(
    <AllData>
        <ScrollToTop smooth/>
        <RouterProvider router={router} />
    </AllData>
);

